import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=e40c8d8c&scoped=true&"
import script from "./BindPhone.vue?vue&type=script&lang=js&"
export * from "./BindPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=e40c8d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40c8d8c",
  null
  
)

export default component.exports